import { Composable, Inject, Vue } from '@natureos/vue-facing-decorator';

import type { ApiResponse, ApiService } from '@/common/services/api.service-new';

import type {
  ChangeDetectionRequest,
  ChangeDetectionResponse,
} from './change-detection.types';

/**
 * Service wrapper for the forest API's change-detection endpoint —
 * `POST /change_detection/candidates`. Mirrors `useClimateService`'s
 * shape: single `getCandidates(payload, signal?)` method, Cognito
 * Bearer attached automatically via `ApiService`, signal forwarded so
 * a re-run (or zone switch) can cancel the in-flight request.
 *
 * Latency: 3–8 s warm, ~6 s cold. Below the 30 s APIGW ceiling for v1
 * AOIs (zone-scale, ≤ 10 km²). The FE should show a spinner with the
 * scene-count hint from `meta` once the request resolves.
 */
@Composable()
export class useChangeDetectionService extends Vue {
  @Inject()
  private readonly api!: ApiService;

  public async getCandidates(
    payload: ChangeDetectionRequest,
    signal?: AbortSignal,
  ): Promise<ApiResponse<ChangeDetectionResponse>> {
    return this.api.post<ChangeDetectionResponse>(
      `${import.meta.env.VITE_FOREST_API}/change_detection/candidates`,
      payload,
      { signal },
    );
  }
}
